import { type AnyRoute, createRoute } from "@tanstack/react-router";

import { clientsReqSchema } from "~/entities/clients";

import { Clients } from "./Clients";

export function createClientsRoute<P extends AnyRoute>(parent: P) {
  return createRoute({
    getParentRoute: () => parent,
    path: "admin/clients",
    component: Clients,
    validateSearch: clientsReqSchema,
    head: () => ({
      meta: [
        {
          title: "Filter Clients",
        },
      ],
    }),
  });
}
